import React from 'react';

const LayersThreeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.66602 10.0009L9.70121 14.0185C9.81053 14.0732 9.86518 14.1005 9.92252 14.1113C9.9733 14.1208 10.0254 14.1208 10.0762 14.1113C10.1335 14.1005 10.1882 14.0732 10.2975 14.0185L18.3327 10.0009M1.66602 14.1676L9.70121 18.1852C9.81053 18.2399 9.86518 18.2672 9.92252 18.278C9.9733 18.2875 10.0254 18.2875 10.0762 18.278C10.1335 18.2672 10.1882 18.2399 10.2975 18.1852L18.3327 14.1676M1.66602 5.83428L9.70121 1.81669C9.81053 1.76203 9.86518 1.7347 9.92252 1.72394C9.9733 1.71442 10.0254 1.71442 10.0762 1.72394C10.1335 1.7347 10.1882 1.76203 10.2975 1.81669L18.3327 5.83428L10.2975 9.85188C10.1882 9.90654 10.1335 9.93387 10.0762 9.94462C10.0254 9.95415 9.9733 9.95415 9.92252 9.94462C9.86518 9.93387 9.81053 9.90654 9.70121 9.85188L1.66602 5.83428Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LayersThreeIcon;
